export default __webpack_public_path__ + "check-2.fe67a0ef.svg";